"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hrRosterStaffingRuleQuerySchema = exports.hrRosterStaffingRuleUpdateSchema = exports.hrRosterStaffingRuleCreateSchema = exports.hrRosterConflictsCheckSchema = exports.hrRosterPublishSchema = exports.hrRosterQuerySchema = exports.hrRosterAssignmentUpdateSchema = exports.hrRosterAssignmentCreateSchema = exports.hrRosterDayTypeEnum = exports.hrRosterStatusEnum = exports.hrRosterAssignmentTypeEnum = void 0;
const zod_1 = require("zod");
/**
 * HR roster contracts — Phase 1C (docs/HR_PHASE1_ARCHITECTURE.md §7, §8).
 *
 * Conflicts are split into BLOCKING (refused, 422) and WARNING (created
 * anyway, surfaced in the response) — never silently either. Roster never
 * writes to `DoctorSchedule`/`DoctorSession` (R-10): a doctor row that
 * contradicts their own session is always a warning, never a block.
 */
exports.hrRosterAssignmentTypeEnum = zod_1.z.enum(['SHIFT', 'ON_CALL', 'WEEKLY_OFF', 'HOLIDAY_DUTY']);
exports.hrRosterStatusEnum = zod_1.z.enum(['DRAFT', 'PUBLISHED', 'CANCELLED']);
exports.hrRosterDayTypeEnum = zod_1.z.enum(['WEEKDAY', 'WEEKEND', 'HOLIDAY']);
exports.hrRosterAssignmentCreateSchema = zod_1.z.object({
    employeeId: zod_1.z.string().uuid(),
    assignmentDate: zod_1.z.coerce.date(),
    shiftId: zod_1.z.string().uuid().optional(),
    departmentId: zod_1.z.string().uuid().optional(),
    assignmentType: exports.hrRosterAssignmentTypeEnum.optional(),
    startOverride: zod_1.z.coerce.date().optional(),
    endOverride: zod_1.z.coerce.date().optional(),
    notes: zod_1.z.string().trim().max(2000).optional(),
});
exports.hrRosterAssignmentUpdateSchema = exports.hrRosterAssignmentCreateSchema.partial();
exports.hrRosterQuerySchema = zod_1.z
    .object({
    employeeId: zod_1.z.string().uuid().optional(),
    departmentId: zod_1.z.string().uuid().optional(),
    from: zod_1.z.coerce.date(),
    to: zod_1.z.coerce.date(),
    status: exports.hrRosterStatusEnum.optional(),
    cursor: zod_1.z.string().min(1).max(512).optional(),
    limit: zod_1.z.coerce.number().int().positive().max(500).default(200),
})
    .refine((v) => v.to >= v.from, { message: '`to` must not be before `from`', path: ['to'] })
    .refine((v) => (v.to.getTime() - v.from.getTime()) / 86_400_000 <= 186, {
    message: 'The roster window may span at most 186 days', path: ['to'],
});
exports.hrRosterPublishSchema = zod_1.z
    .object({
    departmentId: zod_1.z.string().uuid().optional(),
    from: zod_1.z.coerce.date(),
    to: zod_1.z.coerce.date(),
    /** When true, a staffing shortfall BLOCKS publish instead of warning. */
    enforce: zod_1.z.boolean().default(false),
})
    .refine((v) => v.to >= v.from, { message: '`to` must not be before `from`', path: ['to'] });
/** Dry-run — same shape as creating an assignment, but nothing is written. */
exports.hrRosterConflictsCheckSchema = exports.hrRosterAssignmentCreateSchema;
exports.hrRosterStaffingRuleCreateSchema = zod_1.z.object({
    departmentId: zod_1.z.string().uuid().optional(),
    shiftCategory: zod_1.z.string().trim().max(20).optional(),
    dayType: exports.hrRosterDayTypeEnum,
    minHeadcount: zod_1.z.coerce.number().int().nonnegative(),
    skillMix: zod_1.z.record(zod_1.z.unknown()).optional(),
    effectiveFrom: zod_1.z.coerce.date(),
    effectiveTo: zod_1.z.coerce.date().optional(),
});
exports.hrRosterStaffingRuleUpdateSchema = exports.hrRosterStaffingRuleCreateSchema.partial().extend({ isActive: zod_1.z.boolean().optional() });
exports.hrRosterStaffingRuleQuerySchema = zod_1.z.object({ departmentId: zod_1.z.string().uuid().optional() });
//# sourceMappingURL=hr-roster.schema.js.map